// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VeG9","right":"styles_right__3kWXz"};